import { offlineQueue } from './offline-queue';

export async function offlineFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  return offlineQueue.add(url, options);
}

